import component from './i18nLabelsTranslates.vue'

export default component
